import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import EditButton
  from "./buttons/EditButton";

import DeleteButton
  from "./buttons/DeleteButton";

export default function CategoryManager({
  title,
  categoryType,
  userId
}) {
  const [items, setItems] = useState([]);
  const [usageCounts, setUsageCounts] = useState({});

  const [newItemName, setNewItemName] =
  useState('')
  const [showAddForm, setShowAddForm] =
  useState(false)

  const [editingId, setEditingId] = useState(null)
  const [editName, setEditName] = useState('')

  const [deleteId, setDeleteId] = useState(null)
  const [replacementId, setReplacementId] = useState('')


  useEffect(() => {
  loadItems()
  loadUsageCounts()
}, [categoryType])

  async function loadItems() {
    const { data, error } = await supabase
      .from(categoryType)
      .select("*")
      .eq("user_id", userId)
      .eq("is_hidden", false)
      .order("name");

    if (error) {
      console.error(error);
      return;
    }

    setItems(data || []);
  }

  async function loadUsageCounts() {

  let taskColumn = null

  if (categoryType === "focus_area") {
    taskColumn = "focus_area_id"
  }

  if (categoryType === "context") {
    taskColumn = "context_id"
  }

  if (categoryType === "locations") {
    taskColumn = "location_id"
  }

  if (!taskColumn) return

  const { data, error } = await supabase
    .from("tasks")
    .select(taskColumn)
    .eq("user_id", userId)
    .eq("is_hidden", false)

  if (error) {
    console.error(error)
    return
  }

  const counts = {}

  data.forEach(task => {
    const id = task[taskColumn]

    if (!id) return

    counts[id] = (counts[id] || 0) + 1
  })

  setUsageCounts(counts)
}

  async function handleSave() {
  if (!newItemName.trim()) return;

  const { error } = await supabase
    .from(categoryType)
    .insert([
      {
        name: newItemName,
        user_id: userId
      }
    ]);

  if (error) {
    console.error(error);
    return;
  }

  setNewItemName('');
  setShowAddForm(false);

  loadItems();
  loadUsageCounts()
}

function startEdit(item) {
  setEditingId(item.id)
  setEditName(item.name)
}

async function saveEdit(id) {
  const { error } = await supabase
    .from(categoryType)
    .update({
      name: editName
    })
    .eq('id', id)

  if (error) {
    console.error(error)
    return
  }

  setEditingId(null)
  setEditName('')

  loadItems()
  loadUsageCounts()
}

function startDelete(item) {
  const count = usageCounts[item.id] || 0

  if (count === 0) {
    confirmDelete(item.id)
  } else {
    setDeleteId(item.id)
  }
}

async function confirmDelete(id) {
  const { error } = await supabase
    .from(categoryType)
    .update({
      is_hidden: true
    })
    .eq("id", id)

  if (error) {
    console.error(error)
    return
  }

  loadItems()
  loadUsageCounts()
}

async function replaceAndDelete() {
  if (!replacementId || !deleteId) return

  const fieldMap = {
    focus_area: "focus_area_id",
    context: "context_id",
    locations: "location_id"
  }

  const taskField = fieldMap[categoryType]

  await supabase
    .from("tasks")
    .update({
      [taskField]: replacementId
    })
    .eq(taskField, deleteId)

  await confirmDelete(deleteId)

  setDeleteId(null)
  setReplacementId('')
}

  return (
    <div
      style={{
        marginBottom: "50px"
      }}
    >
      <h2>{title}</h2>

      <button
        onClick={() =>
          setShowAddForm(!showAddForm)
        }
      >
        + Add New
      </button>

        {showAddForm && (
          <div style={{ marginTop: '12px' }}>
            <input
              type="text"
              placeholder={`New ${title}`}
              value={newItemName}
              onChange={(e) =>
                setNewItemName(e.target.value)
              }
              style={{
                padding: '8px',
                width: '250px',
                marginRight: '8px'
              }}
            />

            <button onClick={handleSave}>
              Save
            </button>
          </div>
        )}
      <div style={{ marginTop: "20px" }}>
  {items.length === 0 ? (
    <div>No items loaded yet</div>
  ) : (
    items.map((item) => (
      <div
        key={item.id}
        style={{
          padding: "8px 0",
          borderBottom: "1px solid #ddd"
        }}
      >
        {/* MAIN ROW */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span style={{ flex: 1 }}>
            {editingId === item.id ? (
              <input
                value={editName}
                onChange={(e) =>
                  setEditName(e.target.value)
                }
                style={{
                  padding: "4px",
                  width: "250px"
                }}
              />
            ) : (
              <>
                {item.name}

                {usageCounts[item.id] > 0 && (
                  <span
                    style={{
                      color: "#666",
                      fontSize: "0.9rem"
                    }}
                  >
                    {" "}
                    ({usageCounts[item.id]} tasks)
                  </span>
                )}
              </>
            )}
          </span>

          <div
            style={{
              display: "flex",
              gap: "8px"
            }}
          >
            {editingId === item.id ? (
              <button
                onClick={() =>
                  saveEdit(item.id)
                }
              >
                Save
              </button>
            ) : (
              <EditButton
                onClick={() =>
                  startEdit(item)
                }
              />
            )}

            <DeleteButton
              onClick={() =>
                startDelete(item)
              }
            />
          </div>
        </div>

        {/* DELETE REPLACEMENT ROW */}
        {deleteId === item.id && (
          <div style={{ marginTop: "8px" }}>
            <select
              value={replacementId}
              onChange={(e) =>
                setReplacementId(
                  e.target.value
                )
              }
            >
              <option value="">
                Move {usageCounts[item.id] || 0} tasks to...
              </option>

              {items
                .filter(
                  (i) => i.id !== item.id
                )
                .map((i) => (
                  <option
                    key={i.id}
                    value={i.id}
                  >
                    {i.name}
                  </option>
                ))}
            </select>

            <button
              onClick={replaceAndDelete}
              style={{ marginLeft: "8px" }}
            >
              Replace & Delete
            </button>

            <button
              onClick={() => {
                setDeleteId(null)
                setReplacementId('')
              }}
              style={{ marginLeft: "8px" }}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    ))
  )}
</div>
    </div>
  );
}